import React from "react";
import makeStyles from "@material-ui/styles/makeStyles";
import classnames from "classnames";

export interface IImage2dOverlayProps {
    imageSource?: string;
    rotation?: number;
}

const useStyles = makeStyles({
    image: {
        maxWidth: "100%",
        maxHeight: "100%",
        width: "auto",
        height: "auto",
        objectFit: "contain",
    },
});

const MIN_IMAGE_SERVICE_DEGREES_STEP = 90;
const DEGREES_CIRCLE = MIN_IMAGE_SERVICE_DEGREES_STEP * 4;

export const Image2dOverlay: React.FC<IImage2dOverlayProps> = ({ imageSource, rotation = 0 }) => {
    const classes = useStyles();

    if (!imageSource) {
        return null;
    }

    try {
        const url = new URL(imageSource);
        const params = url.searchParams;
        const imageServiceRotation = (DEGREES_CIRCLE - (rotation % DEGREES_CIRCLE)) % DEGREES_CIRCLE;
        if (imageServiceRotation !== 0 && 0 === imageServiceRotation % MIN_IMAGE_SERVICE_DEGREES_STEP) {
            params.append("rotation", `rotate_${imageServiceRotation}`);
        }

        return (
            <img
                className={classnames(classes.image, "image-overlay")}
                src={url.href}
                alt="product customization overlay image"
            />
        );
    } catch {
        return null;
    }
};
